import Modal from "@/components/shared/Modal.tsx";
import PageLoading from "@/components/shared/PageLoading.tsx";
import { useInvite } from "./api";

type InviteDetailsModalArgs = {
  inviteId: string;
  setShowModal: (showModal: boolean) => void;
};

export default function InviteDetailsModal({
  inviteId,
  setShowModal,
}: InviteDetailsModalArgs) {
  const { data: invite, isLoading } = useInvite(inviteId);

  return (
    <Modal
      title={I18n.t("js.invites.index.details-modal.title")}
      onClose={() => setShowModal(false)}
    >
      {isLoading ? (
        <PageLoading />
      ) : (
        <div className="flex flex-col min-h-[368px]">
          <textarea className="grow" disabled value={invite?.body || ""} />
        </div>
      )}
    </Modal>
  );
}
